angular.module('pitch.app').controller('SynchEnquiryModalCtrl',
    function($scope, SiteContext, SynchEnquiry, growl) {
        "use strict";
        $scope.submit = function(enquiry) {
            SiteContext.get().then(function(r) {
                SynchEnquiry.save({
                    site: r.id,
                    enquiry: enquiry
                }, function() {
                    $scope.$close(true);
                }, function() {
                    growl.error('We\'re very sorry but something went wrong when sending your request. Please refresh the page and try again.');
                });
            });
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/SynchEnquiryModalCtrl.js